import createSvgIcon from "./utils/create_icon"

const EditFill = createSvgIcon(<path d="M16.293 3.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414L18.414 10 14 5.586zM12.586 7l-9.293 9.293A1 1 0 0 0 3 17v3a1 1 0 0 0 1 1h3a1 1 0 0 0 .707-.293L17 11.414z" fill="currentColor" />, "EditFill")
export default EditFill
